/* tslint:disable */
/* eslint-disable */
/**
 * Bushfire Platform API
 * ![Bushfire.io](https://bushfire.io/images/logo/logo_96x96.png)  Programmatic access to the Bushfire Platform: live incidents, hotspots, lightning, weather, and analysis.  Your licence determines which data and endpoints you can access. Personal accounts cover private individual use, while commercial, government, education, and organisational use, including raw data access, is available under agreement.  Interested in raw data or an enterprise licence? We\'d love to hear from you at [hello@disasterscience.co](mailto:hello@disasterscience.co).  [Bushfire.io](https://bushfire.io) · [Disaster Science](https://disasterscience.co) · [Terms of Service](https://docs.disasterscience.co/terms)
 *
 * The version of the OpenAPI document: 1.8.36
 * Contact: hello@disasterscience.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BfLicence } from '../models';
// @ts-ignore
import type { BfOrg } from '../models';
// @ts-ignore
import type { BfUser } from '../models';
/**
 * OrganisationApi - axios parameter creator
 */
export const OrganisationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Adds a user to the list of managers for the organisation.
         * @summary Add a manager to an organisation
         * @param {string} orgId The ID of the organisation
         * @param {string} userId The ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addManagerToOrg: async (orgId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('addManagerToOrg', 'orgId', orgId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('addManagerToOrg', 'userId', userId)
            const localVarPath = `/v1/org/{org_id}/managers/{user_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Assigns a licence to the organisation.
         * @summary Assign licence to organisation
         * @param {string} orgId The ID of the organisation
         * @param {string} licenceId The ID of the licence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignLicenceToOrg: async (orgId: string, licenceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('assignLicenceToOrg', 'orgId', orgId)
            // verify required parameter 'licenceId' is not null or undefined
            assertParamExists('assignLicenceToOrg', 'licenceId', licenceId)
            const localVarPath = `/v1/org/{org_id}/licences/{licenceId}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"licenceId"}}`, encodeURIComponent(String(licenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new organisation with the given name and description.
         * @summary Create a new Organisation
         * @param {BfOrg} bfOrg 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrg: async (bfOrg: BfOrg, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfOrg' is not null or undefined
            assertParamExists('createOrg', 'bfOrg', bfOrg)
            const localVarPath = `/v1/org`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfOrg, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes an organisation, removing all users and licences. Org managers can delete their own org.
         * @summary Delete an organisation
         * @param {string} orgId The ID of the organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrg: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('deleteOrg', 'orgId', orgId)
            const localVarPath = `/v1/org/{org_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists all organisations.
         * @summary List all organisations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOrgs: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/org`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets an organisation by ID.
         * @summary Get an organisation by ID
         * @param {string} orgId The ID of the organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrg: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getOrg', 'orgId', orgId)
            const localVarPath = `/v1/org/{org_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Determine the organisation for a given user.
         * @summary Get org for user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgForUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getOrgForUser', 'userId', userId)
            const localVarPath = `/v1/org/user/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of users in the organisation.
         * @summary Users in the organisation
         * @param {string} orgId The ID of the organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgUsers: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getOrgUsers', 'orgId', orgId)
            const localVarPath = `/v1/org/{org_id}/users`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes a user from the list of managers for the organisation.
         * @summary Remove a manager from an organisation
         * @param {string} orgId The ID of the organisation
         * @param {string} userId The ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeManagerFromOrg: async (orgId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('removeManagerFromOrg', 'orgId', orgId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeManagerFromOrg', 'userId', userId)
            const localVarPath = `/v1/org/{org_id}/managers/{user_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unassigns a licence from the organisation.
         * @summary Unassign licence from organisation
         * @param {string} orgId The ID of the organisation
         * @param {string} licenceId The ID of the licence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignLicenceFromOrg: async (orgId: string, licenceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('unassignLicenceFromOrg', 'orgId', orgId)
            // verify required parameter 'licenceId' is not null or undefined
            assertParamExists('unassignLicenceFromOrg', 'licenceId', licenceId)
            const localVarPath = `/v1/org/{orgId}/licences/{licenceId}`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"licenceId"}}`, encodeURIComponent(String(licenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an organisation\'s name (other props later).
         * @summary Update an organisation
         * @param {BfOrg | null} bfOrg 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrg: async (bfOrg: BfOrg | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfOrg' is not null or undefined
            assertParamExists('updateOrg', 'bfOrg', bfOrg)
            const localVarPath = `/v1/org`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfOrg, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganisationApi - functional programming interface
 */
export const OrganisationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganisationApiAxiosParamCreator(configuration)
    return {
        /**
         * Adds a user to the list of managers for the organisation.
         * @summary Add a manager to an organisation
         * @param {string} orgId The ID of the organisation
         * @param {string} userId The ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addManagerToOrg(orgId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfOrg>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addManagerToOrg(orgId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationApi.addManagerToOrg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Assigns a licence to the organisation.
         * @summary Assign licence to organisation
         * @param {string} orgId The ID of the organisation
         * @param {string} licenceId The ID of the licence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignLicenceToOrg(orgId: string, licenceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfLicence>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignLicenceToOrg(orgId, licenceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationApi.assignLicenceToOrg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new organisation with the given name and description.
         * @summary Create a new Organisation
         * @param {BfOrg} bfOrg 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrg(bfOrg: BfOrg, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfOrg>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrg(bfOrg, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationApi.createOrg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes an organisation, removing all users and licences. Org managers can delete their own org.
         * @summary Delete an organisation
         * @param {string} orgId The ID of the organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrg(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrg(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationApi.deleteOrg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists all organisations.
         * @summary List all organisations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllOrgs(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BfOrg>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllOrgs(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationApi.getAllOrgs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets an organisation by ID.
         * @summary Get an organisation by ID
         * @param {string} orgId The ID of the organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrg(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfOrg>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrg(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationApi.getOrg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Determine the organisation for a given user.
         * @summary Get org for user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrgForUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfOrg>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrgForUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationApi.getOrgForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a list of users in the organisation.
         * @summary Users in the organisation
         * @param {string} orgId The ID of the organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrgUsers(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BfUser>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrgUsers(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationApi.getOrgUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Removes a user from the list of managers for the organisation.
         * @summary Remove a manager from an organisation
         * @param {string} orgId The ID of the organisation
         * @param {string} userId The ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeManagerFromOrg(orgId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfOrg>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeManagerFromOrg(orgId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationApi.removeManagerFromOrg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unassigns a licence from the organisation.
         * @summary Unassign licence from organisation
         * @param {string} orgId The ID of the organisation
         * @param {string} licenceId The ID of the licence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unassignLicenceFromOrg(orgId: string, licenceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfLicence>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unassignLicenceFromOrg(orgId, licenceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationApi.unassignLicenceFromOrg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates an organisation\'s name (other props later).
         * @summary Update an organisation
         * @param {BfOrg | null} bfOrg 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrg(bfOrg: BfOrg | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfOrg>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrg(bfOrg, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganisationApi.updateOrg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrganisationApi - factory interface
 */
export const OrganisationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganisationApiFp(configuration)
    return {
        /**
         * Adds a user to the list of managers for the organisation.
         * @summary Add a manager to an organisation
         * @param {string} orgId The ID of the organisation
         * @param {string} userId The ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addManagerToOrg(orgId: string, userId: string, options?: RawAxiosRequestConfig): AxiosPromise<BfOrg> {
            return localVarFp.addManagerToOrg(orgId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Assigns a licence to the organisation.
         * @summary Assign licence to organisation
         * @param {string} orgId The ID of the organisation
         * @param {string} licenceId The ID of the licence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignLicenceToOrg(orgId: string, licenceId: string, options?: RawAxiosRequestConfig): AxiosPromise<BfLicence> {
            return localVarFp.assignLicenceToOrg(orgId, licenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new organisation with the given name and description.
         * @summary Create a new Organisation
         * @param {BfOrg} bfOrg 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrg(bfOrg: BfOrg, options?: RawAxiosRequestConfig): AxiosPromise<BfOrg> {
            return localVarFp.createOrg(bfOrg, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes an organisation, removing all users and licences. Org managers can delete their own org.
         * @summary Delete an organisation
         * @param {string} orgId The ID of the organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrg(orgId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteOrg(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all organisations.
         * @summary List all organisations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOrgs(options?: RawAxiosRequestConfig): AxiosPromise<Array<BfOrg>> {
            return localVarFp.getAllOrgs(options).then((request) => request(axios, basePath));
        },
        /**
         * Gets an organisation by ID.
         * @summary Get an organisation by ID
         * @param {string} orgId The ID of the organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrg(orgId: string, options?: RawAxiosRequestConfig): AxiosPromise<BfOrg> {
            return localVarFp.getOrg(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * Determine the organisation for a given user.
         * @summary Get org for user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgForUser(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<BfOrg> {
            return localVarFp.getOrgForUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of users in the organisation.
         * @summary Users in the organisation
         * @param {string} orgId The ID of the organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgUsers(orgId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<BfUser>> {
            return localVarFp.getOrgUsers(orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes a user from the list of managers for the organisation.
         * @summary Remove a manager from an organisation
         * @param {string} orgId The ID of the organisation
         * @param {string} userId The ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeManagerFromOrg(orgId: string, userId: string, options?: RawAxiosRequestConfig): AxiosPromise<BfOrg> {
            return localVarFp.removeManagerFromOrg(orgId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Unassigns a licence from the organisation.
         * @summary Unassign licence from organisation
         * @param {string} orgId The ID of the organisation
         * @param {string} licenceId The ID of the licence
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignLicenceFromOrg(orgId: string, licenceId: string, options?: RawAxiosRequestConfig): AxiosPromise<BfLicence> {
            return localVarFp.unassignLicenceFromOrg(orgId, licenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an organisation\'s name (other props later).
         * @summary Update an organisation
         * @param {BfOrg | null} bfOrg 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrg(bfOrg: BfOrg | null, options?: RawAxiosRequestConfig): AxiosPromise<BfOrg> {
            return localVarFp.updateOrg(bfOrg, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganisationApi - object-oriented interface
 */
export class OrganisationApi extends BaseAPI {
    /**
     * Adds a user to the list of managers for the organisation.
     * @summary Add a manager to an organisation
     * @param {string} orgId The ID of the organisation
     * @param {string} userId The ID of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addManagerToOrg(orgId: string, userId: string, options?: RawAxiosRequestConfig) {
        return OrganisationApiFp(this.configuration).addManagerToOrg(orgId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Assigns a licence to the organisation.
     * @summary Assign licence to organisation
     * @param {string} orgId The ID of the organisation
     * @param {string} licenceId The ID of the licence
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assignLicenceToOrg(orgId: string, licenceId: string, options?: RawAxiosRequestConfig) {
        return OrganisationApiFp(this.configuration).assignLicenceToOrg(orgId, licenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new organisation with the given name and description.
     * @summary Create a new Organisation
     * @param {BfOrg} bfOrg 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createOrg(bfOrg: BfOrg, options?: RawAxiosRequestConfig) {
        return OrganisationApiFp(this.configuration).createOrg(bfOrg, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes an organisation, removing all users and licences. Org managers can delete their own org.
     * @summary Delete an organisation
     * @param {string} orgId The ID of the organisation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteOrg(orgId: string, options?: RawAxiosRequestConfig) {
        return OrganisationApiFp(this.configuration).deleteOrg(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists all organisations.
     * @summary List all organisations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllOrgs(options?: RawAxiosRequestConfig) {
        return OrganisationApiFp(this.configuration).getAllOrgs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets an organisation by ID.
     * @summary Get an organisation by ID
     * @param {string} orgId The ID of the organisation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrg(orgId: string, options?: RawAxiosRequestConfig) {
        return OrganisationApiFp(this.configuration).getOrg(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Determine the organisation for a given user.
     * @summary Get org for user
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrgForUser(userId: string, options?: RawAxiosRequestConfig) {
        return OrganisationApiFp(this.configuration).getOrgForUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of users in the organisation.
     * @summary Users in the organisation
     * @param {string} orgId The ID of the organisation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrgUsers(orgId: string, options?: RawAxiosRequestConfig) {
        return OrganisationApiFp(this.configuration).getOrgUsers(orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Removes a user from the list of managers for the organisation.
     * @summary Remove a manager from an organisation
     * @param {string} orgId The ID of the organisation
     * @param {string} userId The ID of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeManagerFromOrg(orgId: string, userId: string, options?: RawAxiosRequestConfig) {
        return OrganisationApiFp(this.configuration).removeManagerFromOrg(orgId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unassigns a licence from the organisation.
     * @summary Unassign licence from organisation
     * @param {string} orgId The ID of the organisation
     * @param {string} licenceId The ID of the licence
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unassignLicenceFromOrg(orgId: string, licenceId: string, options?: RawAxiosRequestConfig) {
        return OrganisationApiFp(this.configuration).unassignLicenceFromOrg(orgId, licenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an organisation\'s name (other props later).
     * @summary Update an organisation
     * @param {BfOrg | null} bfOrg 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateOrg(bfOrg: BfOrg | null, options?: RawAxiosRequestConfig) {
        return OrganisationApiFp(this.configuration).updateOrg(bfOrg, options).then((request) => request(this.axios, this.basePath));
    }
}

